import type { FailedRequestInfo } from "./http.type";

export class UnauthorizedException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "UnauthorizedException";
  }
}

export class ForbiddenException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "ForbiddenException";
  }
}

export class MutationException extends Error {
  requestInfo: FailedRequestInfo;

  constructor(requestInfo: FailedRequestInfo, message?: string) {
    super(message);
    this.name = "MutationException";
    this.requestInfo = requestInfo;
  }
}
